export const gnbMenuLinks = {
  'saju-input': {
    name: '사주입력',
    link: '/saju-input',
    subMenu: [],
  },
  selection: {
    name: '택일달력',
    link: '/selection?tab=perpetual',
    basePath: '/selection',
    subMenu: [],
  },
  'saju-service': {
    name: '낭만분석',
    link: '/saju-service',
    subMenu: [],
  },
  fortune: {
    name: '낭만일진',
    link: '/fortune',
    subMenu: [],
  },
  purchase: {
    name: '서비스구매',
    link: '/purchase/tickets',
    basePath: '/purchase',
    subMenu: [
      { name: '낭만 분석권 구매', link: '/purchase/tickets' },
      { name: '낭만 포인트 충전', link: '/purchase/points' },
      { name: '선물함', link: '/purchase/gift-box' },
    ],
    className: `st-guide`,
  },
  'nangman-center': {
    name: '낭만센터',
    link: '/nangman-center/notice',
    basePath: '/nangman-center',
    subMenu: [
      { name: '공지사항', link: '/nangman-center/notice', icon: 'icon-notice' },
      { name: '생활 속 명리', link: '/nangman-center/word', icon: 'icon-counseling' },
      { name: '이벤트', link: '/nangman-center/event', icon: 'icon-event' },
      { name: '낭만에세이', link: '/nangman-center/essay', icon: 'icon-essay' },
      { name: '자주 묻는 질문', link: '/nangman-center/faq', icon: 'icon-faq' },
    ],
  },
  'about-nangman': {
    name: '낭만만세력은?',
    link: '/about-nangman',
    subMenu: [],
    className: 'st-guide devOnly',
  },
};
